import { Box, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid, GridColumnProps, SelectFilterComponent, SelectFloatingFilterComponent } from '@roc/ui';
import { observer } from 'mobx-react';

const useStyles = makeStyles(() => ({
  gridContainer: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    height: '65vh',
    overflow: 'hidden',
  },
}));

interface LenderLicensesGridProps {
  gridStore: any;
  columns: GridColumnProps[];
}

export const LenderLicensesGrid = observer(({ gridStore, columns }: LenderLicensesGridProps) => {
  const classes = useStyles();

  const rows = gridStore?.gridData?.data?.rows || [];

  return (
    <Box>
      <Grid item className={classes.gridContainer}>
        <DataGrid
          columns={columns}
          rows={rows}
          isLoading={gridStore?.isLoading}
          showFilters={gridStore?.showFilters}
          sortModel={gridStore?.sortModel}
          filterModel={gridStore?.filterModel}
          paginationData={gridStore?.gridData?.meta}
          setPageNumber={gridStore?.setPageNumber}
          frameworkComponents={{
            selectFilter: SelectFilterComponent,
            selectFloatingFilter: SelectFloatingFilterComponent,
          }}
          onFilterChanged={params =>
            gridStore.setFilterModel?.(params.api.getFilterModel())
          }
          onSortChanged={params =>
            gridStore.setSortModel?.(params.api.getSortModel())
          }
        />
      </Grid>
    </Box>
  );
});
